import { Td } from "@chakra-ui/react"

export const TableHead = () => {
    return (
        <>
             <Td> S/N</Td>
             <Td> Offer Type</Td>
             <Td> Category</Td>
             <Td> Total Clicks</Td>
             <Td>Description</Td>
        </>
    )
}